export const loyaltyConfig = {
  loyaltyConfig: "Loyalty Config",
  rate: "Rate",
  bet: "Bet",
  amountPerPoint: "Amount per Point",
  cashPerPoint: "Cash point rate",
  maxRedeemPoint: "Max Redeem point",
  expiry: "Expiry",
  month: "Month",
  activated: "Activated",
  cashrewardEnable: "CashReward Enable",
  save: "Save",
  redeemFortuneWheelLimit: "redeemFortuneWheelLimit",
  fortuneWheelConfig:"Fortune Wheel Config",
  addReward:"Add Reward",
  name:"Name",
  reward:"Rewards",
  point:"Point"
};
